import { api } from './api';

// Define a KnowledgeBase service
export const knowledgeBaseApi = api.injectEndpoints({
  reducerPath: 'knowledgeBaseApi',
  tagTypes: ['KnowledgeBases'],
  endpoints: (builder) => ({
    getKnowledgeBaseDocuments: builder.query({
      query: ({ knowledgeBaseId, page = 0, size = 10, sort }) => {
        const params = new URLSearchParams({
          page: page.toString(),
          size: size.toString()
        });

        if (sort) {
          params.append('sort', sort);
        }

        return {
          url: `/api/administration/knowledgeBases/${knowledgeBaseId}/documents?${params.toString()}`,
          method: 'GET'
        };
      },
      providesTags: ['KnowledgeBaseDocuments']
    }),

    deleteKnowledgeBaseDocuments: builder.mutation({
      query: ({ id, documentIds }) => ({
        url: `/api/administration/knowledgeBases/${id}/documents`,
        method: 'DELETE',
        body: documentIds
      }),
      invalidatesTags: ['KnowledgeBaseDocuments']
    }),

    getKnowledgeBase: builder.query({
      query: (id) => ({
        url: `/api/administration/knowledgeBases/${id}`,
        method: 'GET'
      }),
      providesTags: ['KnowledgeBases']
    }),
    getKnowledgeBases: builder.query({
      query: () => ({
        url: '/api/administration/knowledgeBases',
        method: 'GET'
      }),
      providesTags: ['KnowledgeBases']
    }),
    createKnowledgeBase: builder.mutation({
      query: (knowledgeBaseRequest) => ({
        url: '/api/administration/knowledgeBases',
        method: 'POST',
        body: knowledgeBaseRequest
      }),
      invalidatesTags: ['KnowledgeBases']
    }),
    updateKnowledgeBase: builder.mutation({
      query: ({ id, knowledgeBaseRequest }) => ({
        url: `/api/administration/knowledgeBases/${id}`,
        method: 'PATCH',
        body: knowledgeBaseRequest
      }),
      invalidatesTags: ['KnowledgeBases']
    }),
    deleteKnowledgeBase: builder.mutation({
      query: (id) => ({
        url: `/api/administration/knowledgeBases/${id}`,
        method: 'DELETE'
      }),
      invalidatesTags: ['KnowledgeBases']
    }),
    bulkDeleteKnowledgeBases: builder.mutation({
      query: (ids) => ({
        url: `/api/administration/knowledgeBases`,
        method: 'DELETE',
        body: ids
      }),
      invalidatesTags: ['KnowledgeBases']
    })
  })
});

export const {
  useGetKnowledgeBaseDocumentsQuery,
  useDeleteKnowledgeBaseDocumentsMutation,
  useGetKnowledgeBasesQuery,
  useGetKnowledgeBaseQuery,
  useCreateKnowledgeBaseMutation,
  useUpdateKnowledgeBaseMutation,
  useDeleteKnowledgeBaseMutation,
  useBulkDeleteKnowledgeBasesMutation
} = knowledgeBaseApi;
